module.exports = __webpack_public_path__ + "static/img/smag-logo.tid5.619a325.png";